import { DashboardListPage } from '../pages'

export default function DashboardView() {
  return <DashboardListPage />
}